import moment from 'moment';

export function formatDate(date, format = 'MMMM Do YYYY') {
  return moment(date).utc().format(format);
}

export function formatDateStandard(date, format = 'MM/DD/YYYY') {
  return moment(date).utc().format(format);
}

export function formatTime(time, format = 'h:mm a') {
  return moment(time, 'HH:mm:ss').format(format);
}

export const getFormattedTime = (event) =>
  `${formatTime(event?.parameters_event?.hour_start_event, 'hh:mm A')} - ${formatTime(
    event?.parameters_event?.hour_end_event,
    'hh:mm A',
  )}`;

export const getRoleUser = (roleId) => {
  const role = {
    1: 'Vendor',
    2: 'Venue',
    5: 'Admin',
  };
  return role[roleId];
};
export function formatCurrency(currency) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return formatter.format(currency);
}

export function constraintValue(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

export function capitalize([first, ...rest]) {
  return `${first?.toUpperCase()}${rest?.join('')}`;
}

export const formatPhoneNumber = (phoneNumber) => {
  // Remove all non-digit characters
  const cleaned = phoneNumber.replace(/\D/g, '');
  // Check if it's a valid 10-digit number
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  // Handle numbers with country code (assuming +1)
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    return `(${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }
  // Return original number if it doesn't match expected formats
  return phoneNumber;
};
